import TileWMS from 'ol/source/TileWMS';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Group from 'ol/layer/Group';
import GeoJSON from 'ol/format/GeoJSON'
import {Vector as VectorSource} from 'ol/source.js';
import {Vector as VectorLayer} from 'ol/layer.js';
import {Circle, Fill, Stroke, Style,Icon,Text} from 'ol/style.js';


function iconStyleFunc(feature) {

  var zIndex = 20; 

  if (feature.get("funkcje_centralne_koscielne")!= null & feature.get("charakter_osady")== "miasto"){
    var iconName = "miasto_parafia.png"
    var scale=0.25
    var anchor= [0.5, 0.28]
  }
  else if (feature.get("funkcje_centralne_koscielne")== null & feature.get("charakter_osady")== "miasto"){
    var iconName = "miasto.png"
    var scale=0.25
    var anchor= [0.5, 0.5]
  }
  else if (feature.get("funkcje_centralne_koscielne")!= null & (feature.get("charakter_osady")== "wieś"|feature.get("charakter_osady")== "przedmieście"|feature.get("charakter_osady")== "przedmieście lub wieś")){
    var iconName = "wies_parafia.png"
    var scale=0.2
    var anchor= [0.5, 0.45]
  }
  else if (feature.get("funkcje_centralne_koscielne")== null & (feature.get("charakter_osady")== "wieś"|feature.get("charakter_osady")== "przedmieście"|feature.get("charakter_osady")== "przedmieście lub wieś")){
    var iconName = "wies.png"
    var scale=0.2
    var anchor= [0.5, 0.5]
  }
  else {
      var iconName ="inne.png"
      var scale=0.2
      var anchor= [0.5, 0.5]
    }

  var iconStyle = [new Style({
      image: new Icon(({
          anchorOrigin:'bottom-left',
          anchor: anchor, 
          anchorXUnits: "fraction",
          anchorYUnits: "fraction",
          opacity: 1,
          scale:scale,
          src: "./assets/images/" + iconName,  
          zIndex: zIndex,
      })),
      zIndex: zIndex,
      text: new Text({
        font: '15px Lato',
        textBaseline:'bottom',
        textAlign:'left',
        offsetX:10,
        offsetY:-10,
        text: feature.get("nazwa_16w"),
        fill: new Fill({
          color: '#000'
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3
        })
      })
  })];
return iconStyle;
}

function rejestrStyleFunc(feature) {

  var rejestrStyle = [new Style({
      image: new Circle({
        fill: new Fill({
          color: 'rgba(51,153,204,0.4)',
        }),
        stroke: new Stroke({
          color: 'rgba(51,153,204,0.4)',
          width: 1.25,
        }),
        radius: 11,
      }),
      
  })];
return rejestrStyle;
}

function boundariesStyleFunc(feature,zoom) {

  var zIndex = 99; 
  if (zoom>20){
  if (feature.get('woj_p')){
    if(feature.get('woj_p')=='księstwo siewierskie'){var strokeColor='rgb(0, 0, 0)'
    var width=4
    var lineDash= []
    var name='KSIĘSTWO SIEWIERSKIE'
    var font= 'bold 22px Lato'
    var offsetY=25}else if(feature.get('woj_p')=='ziemia lęborsko-bytowska'){var strokeColor='rgb(0, 0, 0)'
    var width=4
    var lineDash= []
    var name='ZIEMIA LĘBORSKO-BYTOWSKA'
    var font= 'bold 22px Lato'
    var offsetY=25}else if(feature.get('woj_p')=='ziemia dobrzyńska'){var strokeColor='rgb(0, 0, 0)'
    var width=4
    var lineDash= []
    var name='ZIEMIA DOBRZYŃSKA'
    var font= 'bold 22px Lato'
    var offsetY=25}else{var strokeColor='rgb(0, 0, 0)'
    var width=4
    var lineDash= []
    var name='WOJ. '+feature.get('woj_p').toUpperCase()
    var font= 'bold 22px Lato'
    var offsetY=25}
    
    
  }

  if (feature.get('ziemia_p')){
    var strokeColor='rgb(0, 0, 0)'
    var width=3
    var lineDash= [5, 20]
    var name='ZIEM. '+feature.get('ziemia_p').toUpperCase()
    var font= '20px Lato'
    var offsetY=-25
  }

  if (feature.get('powiat_p')){
    if(feature.get('powiat_p')=='księstwo siewierskie'){var strokeColor='rgb(0, 0, 0)'
    var width=2
    var lineDash= [5, 10, 0 ,10]
    var name=''
    var font= '20px Lato'
    var offsetY=0

    }else if(feature.get('powiat_p')=='ziemia lęborsko-bytowska'){var strokeColor='rgb(0, 0, 0)'
    var width=2
    var lineDash= [5, 10, 0 ,10]
    var name=''
    var font= '20px Lato'
    var offsetY=0

    }else{var strokeColor='rgb(0, 0, 0)'
    var width=2
    var lineDash= [5, 10, 0 ,10]
    var name='POW. '+feature.get('powiat_p').toUpperCase()
    var font= '20px Lato'
    var offsetY=0}
    
  }

  if (feature.get('g_parafia')){
    var strokeColor='rgb(204, 107, 167)'
    var width=1
    var lineDash= [1.5,2.5]
    var name='PAR. '+feature.get('g_parafia').toUpperCase()
    var font= '16px Lato'
    var offsetY=50
  }

  if (feature.get('g_dekanat')){
    if(feature.get('g_dekanat')=='Ostrzeszów'){var strokeColor='rgb(204, 107, 167)'
    var width=2
    var lineDash= [5, 10, 0 ,10]
    var name='ARCHIPREZBITERAT OSTRZESZÓW'
    var font= '18px Lato'
    var offsetY=25}else{var strokeColor='rgb(204, 107, 167)'
    var width=2
    var lineDash= [5, 10, 0 ,10]
    var name='DEK. '+feature.get('g_dekanat').toUpperCase()
    var font= '18px Lato'
    var offsetY=25}
    
  }

  if (feature.get('g_archidia')){
    if (feature.get('g_archidia')=='Kielce Pr'){var strokeColor='rgb(204, 107, 167)'
    var width=2
    var lineDash= []
    var name='PREPOZYTURA KIELCE'
    var font= 'bold 20px Lato'
    var offsetY=0}else if (feature.get('g_archidia')=='Wieluń Ter'){var strokeColor='rgb(204, 107, 167)'
    var width=2
    var lineDash= []
    var name='TERYTORIUM WIELUŃ'
    var font= 'bold 20px Lato'
    var offsetY=0}else if (feature.get('g_archidia')=='Tarnów Pr'){var strokeColor='rgb(204, 107, 167)'
    var width=2
    var lineDash= []
    var name='PREPOZYTURA TARNÓW'
    var font= 'bold 20px Lato'
    var offsetY=0}else if (feature.get('g_archidia')=='Kielce Dz'){var strokeColor='rgb(204, 107, 167)'
    var width=2
    var lineDash= []
    var name='DZIEKANIA KIELCE'
    var font= 'bold 20px Lato'
    var offsetY=0}else if (feature.get('g_archidia')===null){var strokeColor='rgb(204, 107, 167)'
    var width=0
    var offsetY=0}else{var strokeColor='rgb(204, 107, 167)'
    var width=2
    var lineDash= []
    var name='ARCH. '+feature.get('g_archidia').toUpperCase()
    var font= 'bold 20px Lato'
    var offsetY=0}
    
  }

  if (feature.get('g_diecezja')){
    var strokeColor='rgb(204, 107, 167)'
    var width=4
    var lineDash= []
    var name='DIEC. '+feature.get('g_diecezja').toUpperCase()
    var font= 'bold 22px Lato'
    var offsetY=-25
  }

  }
  else{
    var font= '0px Lato'
  }


  var boundariesStyle = [new Style({
    stroke: new Stroke({
      color: strokeColor,
      width: width,
      lineDash:lineDash,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0)',
    }),
    zIndex: zIndex,
    text: new Text({
        font: font,
        text: name,
        offsetY:offsetY,
        backgroundFill:new Fill({
          color: 'rgba(255, 255, 255, 0.5)'
        }),
        fill: new Fill({
          color: strokeColor
        }),
        backgroundStroke:new Stroke({
          color: 'rgba(255, 255, 255, 0.5)',
          width: 3
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3
        })
    })
  })];
return boundariesStyle;
}
//-----------extent---------------

var koscianskie_extent=[1743420.0000000000000000,6722200.5000000000000000,1939028.2500000000000000,6897628.5000000000000000];
var poznanskie_extent=[1697764.2500000000000000,6800756.0000000000000000,1974371.0000000000000000,7007012.0000000000000000];
var wschowska_extent=[1801616.1250000000000000,6747958.5000000000000000,1845345.1250000000000000,6796690.0000000000000000];
var waleckie_extent=[1774498.0000000000000000,7007179.5000000000000000,1858572.5000000000000000,7125142.0000000000000000];
var gnieznienskie_extent=[1898054.1250000000000000,6857692.5000000000000000,2042457.6250000000000000,6956976.5000000000000000];
var kaliskie_extent=[1933504.2500000000000000,6712383.5000000000000000,2080075.1250000000000000,6826892.0000000000000000];
var kcynskie_extent=[1872721.1250000000000000,6925382.0000000000000000,2008528.5000000000000000,7002701.5000000000000000];
var koninskie_extent=[1981077.7500000000000000,6797871.5000000000000000,2094515.0000000000000000,6890705.5000000000000000];
var nakielskie_extent=[1865577.7500000000000000,6995921.5000000000000000,1996277.5000000000000000,7083910.5000000000000000];
var pyzdrskie_extent=[1891224.5000000000000000,6736745.0000000000000000,2015602.5000000000000000,6873939.0000000000000000];
var ostrzeszowski_extent=[1982643.0000000000000000,6660708.0000000000000000,2025895.3750000000000000,6724852.0000000000000000];
var piotrkowski_extent=[2130084.0000000000000000,6640153.5000000000000000,2229718.0000000000000000,6744392.0000000000000000];
var radomszczanski_extent=[2102356.0000000000000000,6580579.5000000000000000,2211602.5000000000000000,6670897.5000000000000000];
var sieradzki_extent=[2045615.0000000000000000,6676556.5000000000000000,2128480.2500000000000000,6809351.0000000000000000];
var szadkowski_extent=[2083207.7500000000000000,6694606.0000000000000000,2165828.0000000000000000,6817383.5000000000000000];
var wielunski_extent=[1995705.8750000000000000,6601812.0000000000000000,2159598.7500000000000000,6697190.0000000000000000];
var gostyninska_extent=[2139300.0000000000000000,6821441.5000000000000000,2256423.0000000000000000,6902087.5000000000000000];
var rawska_extent=[2194641.2500000000000000,6729367.5000000000000000,2312588.2500000000000000,6804304.0000000000000000];
var sochaczewska_extent=[2192555.2500000000000000,6749102.0000000000000000,2341676.5000000000000000,6877063.0000000000000000];
var wiska_extent=[2461637.7500000000000000,7005945.5000000000000000,2521680.2500000000000000,7111093.0000000000000000];
var lomzynska_extent=[2385174.2500000000000000,6958441.0000000000000000,2523747.2500000000000000,7080947.5000000000000000];
var nurska_extent=[2346289.5000000000000000,6861245.0000000000000000,2500595.2500000000000000,6976538.5000000000000000];
var zakroczymska_extent=[2262678.5119127100333571,6872474.7368281399831176,2351270.4356024102307856,6942747.5166815295815468];
var wyszogrodzka_extent=[2224035.7500000000000000,6853837.5000000000000000,2269684.2500000000000000,6914737.5000000000000000];
var czerska_extent=[2295794.7500000000000000,6722235.5000000000000000,2461667.0000000000000000,6850187.5000000000000000];
var rozanska_extent=[2335621.5000000000000000,6936807.0000000000000000,2395649.2500000000000000,7012808.0000000000000000];
var lukowski_extent=[2443210.0000000000000000,6729115.5000000000000000,2545884.0000000000000000,6839439.0000000000000000];
var lubelski_extent=[2426020.0000000000000000,6551927.0000000000000000,2566782.5000000000000000,6752754.5000000000000000];
var urzedowski_extent=[2426831.7500000000000000,6552526.5000000000000000,2513019.7500000000000000,6632255.5000000000000000];
var warszawska_extent=[2284852.7500000000000000,6778117.5000000000000000,2404034.5000000000000000,6889525.5000000000000000];
var liwska_extent=[2422915.5000000000000000,6812201.0000000000000000,2473406.0000000000000000,6859049.5000000000000000];
var proszowski_extent=[2131767.7500000000000000,6449105.5000000000000000,2299502.7500000000000000,6521433.5000000000000000];
var szczyrzycki_extent=[2186034.2500000000000000,6370656.0000000000000000,2305682.7500000000000000,6470808.5000000000000000];
var lelowski_extent=[	2079851.1250000000000000,6513454.0000000000000000,2240522.0000000000000000,6621471.0000000000000000];
var ksieski_extent=[2181447.5000000000000000,6495636.5000000000000000,2282004.0000000000000000,6577804.0000000000000000];
var slaski_extent=[2119531.5000000000000000,6379998.0000000000000000,2201857.0000000000000000,6463915.5000000000000000];
var biecki_extent=[2324588.5000000000000000,6345624.5000000000000000,2419902.2500000000000000,6427924.5000000000000000];
var sadecki_extent=[2234585.0000000000000000,6341770.5000000000000000,2340017.0000000000000000,6447017.0000000000000000];
var malborskie_extent=[2085302.8750000000000000,7128038.0000000000000000,2185008.0000000000000000,7231534.0000000000000000];
var plocki_extent=[2171064.5000000000000000,6878795.0000000000000000,2234167.5000000000000000,6934396.5000000000000000];
var bielski_extent=[2182638.0000000000000000,6908209.0000000000000000,2237437.5000000000000000,6942641.0000000000000000];
var sierpecki_extent=[2171333.0000000000000000,6933588.0000000000000000,2216654.0000000000000000,7011443.0000000000000000];
var raciaski_extent=[2207790.2500000000000000,6926158.5000000000000000,2259696.2500000000000000,6973265.0000000000000000];
var plonski_extent=[2233439.0000000000000000,6911919.5000000000000000,2274087.7500000000000000,6952356.0000000000000000];
var szrenski_extent=[2208714.7500000000000000,6962794.0000000000000000,2275864.7500000000000000,7022760.0000000000000000];
var mlawski_extent=[2266614.0000000000000000,6980360.5000000000000000,2296770.7500000000000000,7044960.500000000000000];
var niedzborski_extent=[2258097.0000000000000000,6928741.5000000000000000,2293864.7500000000000000,6979131.0000000000000000];
var orlowski_extent=[2153360.7500000000000000,6792790.5000000000000000,2213608.7500000000000000,6855465.5000000000000000];
var leczycki_extent=[2080078.3750000000000000,6753600.5000000000000000,2178996.2500000000000000,6858875.5000000000000000];
var brzezinski_extent=[2159556.0000000000000000,6701159.5000000000000000,2269446.5000000000000000,6795936.0000000000000000];
var ciechanowska_extent=[2253427.2500000000000000,6870991.5000000000000000,2368956.0000000000000000,7042691.0000000000000000];
var chelminskie_extent=[2025924.5000000000000000,6995384.5000000000000000,2222967.7500000000000000,7096871.0000000000000000];
var kruszwicki_extent=[2006018.6250000000000000,6881164.0000000000000000,2046197.0000000000000000,6925133.5000000000000000];
var radziejowski_extent=[2044743.3750000000000000,6870316.0000000000000000,2081598.8750000000000000,6929834.5000000000000000];
var kowalski_extent=[2105241.0000000000000000,6859907.0000000000000000,2169331.0000000000000000,6916069.5000000000000000];
var brzeski_extent=[2061522.7500000000000000,6875301.5000000000000000,2136903.5000000000000000,6959963.5000000000000000];
var przedecki_extent=[2066772.0000000000000000,6849346.5000000000000000,2128270.0000000000000000,6886665.0000000000000000];
var tczewski_extent=[1976706.0000000000000000,7125445.0000000000000000,2116848.7500000000000000,7232627.0000000000000000];
var nowski_extent=[2050380.3750000000000000,7069164.0000000000000000,2095651.2500000000000000,7141005.5000000000000000];
var swiecki_extent=[2011558.5000000000000000,7028073.0000000000000000,2080773.6250000000000000,7115212.5000000000000000];
var tucholski_extent=[1946739.3750000000000000,7046965.5000000000000000,2019636.8750000000000000,7172900.5000000000000000];
var czluchowski_extent=[1872968.6250000000000000,7082415.0000000000000000,1985232.0000000000000000,7183853.0000000000000000];
var gdanski_extent=[2003080.0000000000000000,7208753.0000000000000000,2090070.6250000000000000,7322766.5000000000000000];
var mirachowski_extent=[1958911.6250000000000000,7183476.0000000000000000,2026779.0000000000000000,7272596.5000000000000000];
var pucki_extent=[2002084.6250000000000000,7265039.5000000000000000,2078957.3750000000000000,7329325.0000000000000000];
var bydgoski_extent=[1970350.0000000000000000,6956452.0000000000000000,2032635.1250000000000000,7061473.0000000000000000];
var inowroclawski_extent=[2011769.0000000000000000,6911074.0000000000000000,2100094.5000000000000000,6984306.0000000000000000];
var rypinski_extent=[2125946.5000000000000000,6956836.5000000000000000,2196184.5000000000000000,7025485.0000000000000000];
var dobrzynski_extent=[2118522.2500000000000000,6906675.5000000000000000,2178529.5000000000000000,6944994.0000000000000000];
var lipnowski_extent=[2081515.1250000000000000,6936808.5000000000000000,2181653.7500000000000000,6999292.0000000000000000];
var bielski_pdl_extent=[2495206.5000000000000000,6903289.0000000000000000,2607868.2500000000000000,7139004.5000000000000000];
var checinski_extent=[2191336.7500000000000000,6552726.0000000000000000,2331751.0000000000000000,6643337.5000000000000000];
var opoczynski_extent=[2215920.2500000000000000,6631687.0000000000000000,2315865.2500000000000000,6729762.5000000000000000];
var pilznenski_extent=[2295552.2500000000000000,6390599.5000000000000000,2449573.0000000000000000,6516842.0000000000000000];
var radomski_extent=[2281901.0000000000000000,6621279.0000000000000000,2446555.2500000000000000,6744810.5000000000000000];
var sandomierski_extent=[2314618.5000000000000000,6486574.0000000000000000,2469986.2500000000000000,6640399.5000000000000000];
var stezycki_extent=[2385743.7500000000000000,6707587.0000000000000000,2495104.2500000000000000,6784230.5000000000000000];
var wislicki_extent=[2266603.0000000000000000,6468385.5000000000000000,2364592.5000000000000000,6582438.5000000000000000];



///---------------linijka-----------------

export const source = new VectorSource();

const vector = new VectorLayer({
  source: source,
  displayInLayerSwitcher:false,
  layerName:'ruler',
  style: {
    'fill-color': 'rgba(255, 255, 255, 0.2)',
    'stroke-color': '#ffcc33',
    'stroke-width': 2,
    'circle-radius': 7,
    'circle-fill-color': '#ffcc33',
  },
});

// OSM

const osm = new TileLayer({
  title: "OSM",
  source: new OSM(),
  visible: true,
  infoTitle:'OSM-WMS',
  layerName:'osm',
  infoContent:'osm',
});


// AHP

export const miejscowosci_source = new VectorSource({
  url: function () {
    return (
      'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
      'version=1.1.0&request=GetFeature&typename=geonode%3Amiejscowosci_20&' +
      'outputFormat=application/json&srsname=EPSG:3857'
    )},
  format: new GeoJSON(),
});

export const miejscowosci = new VectorLayer({
  source: miejscowosci_source,
  visible: true,
  minZoom: 9,
  title: 'Miejscowości',
  infoTitle:'Miejscowości',
  infoContent:'miejscowosci',
  layerName:'miejscowosci',
  permalink:"miejscowosci",
  style: iconStyleFunc,
  declutter: true,
  zIndex:100,
});
export const capital = new VectorLayer({
  source: new VectorSource({
    url: function () {
      return (
        'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
        'version=1.1.0&request=GetFeature&typename=geonode:miejscowosci&' +
        'outputFormat=application/json&srsname=EPSG:3857&'+
        'cql_filter=funkcje_centralne_panstwowe%20like%20%27%25powiat%25%27'
        
      )},
    format: new GeoJSON(),
  }),
  visible: miejscowosci.getVisible(),
  title: 'Capital',
  infoTitle:'Miejscowości capital',
  layerName:'miejscowoscicapital',
  style: iconStyleFunc,
  displayInLayerSwitcher:false,
  declutter: true,
  zIndex:9999,
});

miejscowosci.on('change:visible', function(){
  var visibility=miejscowosci.getVisible();
  capital.setVisible(visibility)
});


export const archidiakonaty = new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: function () {
      return ( 'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
      'version=1.1.0&request=GetFeature&typename=geonode:archidiakonaty&' +
      'outputFormat=application/json&srsname=EPSG:3857&'
      )},
    serverType: 'geoserver',
    transition: 0,
  }),
  style:boundariesStyleFunc,
  visible: false,
  title: 'Archidiakonaty',
  infoTitle:'Archidiakonaty [Atlas historyczny Polski XVI w.]',
  infoContent:'archidiakonaty',
  layerName:'archidiakonaty',
  permalink:"archidiakonaty"
});
export const diecezje = new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: function () {
      return ( 'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
      'version=1.1.0&request=GetFeature&typename=geonode:diecezje&' +
      'outputFormat=application/json&srsname=EPSG:3857&'
      )},
    serverType: 'geoserver',
    transition: 0,
  }),
  style:boundariesStyleFunc,
  visible: false,
  title: 'Diecezje',
  infoTitle:'Diecezje [Atlas historyczny Polski XVI w.]',
  infoContent:'diecezje',
  layerName:'diecezje',
  permalink:"diecezje"
});
export const dekanaty = new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: function () {
      return ( 'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
      'version=1.1.0&request=GetFeature&typename=geonode:dekanaty0&' +
      'outputFormat=application/json&srsname=EPSG:3857&'
      )},
    serverType: 'geoserver',
    transition: 0,
  }),
  style:boundariesStyleFunc,
  visible: false,
  title: 'Dekanaty',
  infoTitle:'Dekanaty [Atlas historyczny Polski XVI w.]',
  infoContent:'dekanaty',
  layerName:'dekanaty',
  permalink:"dekanaty"
});
export const parafie = new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: function () {
      return ( 'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
      'version=1.1.0&request=GetFeature&typename=geonode:parafie10&' +
      'outputFormat=application/json&srsname=EPSG:3857&'
      )},
    serverType: 'geoserver',
    transition: 0,
  }),
  style:boundariesStyleFunc,
  visible: false,
  title: 'Parafie',
  infoTitle:'Parafie [Atlas historyczny Polski XVI w.]',
  infoContent:'parafie',
  layerName:'parafie',
  permalink:"parafie"
});

export const wojewodztwa = new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: function () {
      return ( 'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
      'version=1.1.0&request=GetFeature&typename=geonode:wojewodztwa&' +
      'outputFormat=application/json&srsname=EPSG:3857&'
      )},
    serverType: 'geoserver',
    transition: 0,
  }),
  style: boundariesStyleFunc,
  visible: false,
  title: 'Województwa',
  infoTitle:'Województwa [Atlas historyczny Polski XVI w.]',
  infoContent:'wojewodztwa',
  layerName:'wojewodztwa',
  permalink:"wojewodztwa"
});

export const powiaty = new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: function () {
      return ( 'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
      'version=1.1.0&request=GetFeature&typename=geonode:powiaty&' +
      'outputFormat=application/json&srsname=EPSG:3857&'
      )},
    serverType: 'geoserver',
    transition: 0,
  }),
  style:boundariesStyleFunc,
  visible: false,
  title: 'Powiaty',
  infoTitle:'Powiaty [Atlas historyczny Polski XVI w.]',
  infoContent:'powiaty',
  layerName:'powiaty',
  permalink:"powiaty",
});

export const ziemie = new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: function () {
      return ( 'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
      'version=1.1.0&request=GetFeature&typename=geonode:ziemie&' +
      'outputFormat=application/json&srsname=EPSG:3857&'
      )},
    serverType: 'geoserver',
    transition: 0,
  }),
  style:boundariesStyleFunc,
  visible: false,
  title: 'Ziemie',
  infoTitle:'Ziemie [Atlas historyczny Polski XVI w.]',
  infoContent:'ziemie',
  layerName:'ziemie',
  permalink:"ziemie",
});


export const drogi = new TileLayer({
  source: new TileWMS({
    url: 'https://data.atlasfontium.pl/geoserver/wms',
    params: {'LAYERS': 'geonode:drogi', 'TILED': true},
    serverType: 'geoserver',
    transition: 0,
  }),
  visible: false,
  title: 'Drogi',
  infoTitle:'Drogi',
  infoContent:'drogi',
  layerName:'drogi',
  permalink:"drogi"
});

export const akweny = new TileLayer({
  source: new TileWMS({
    url: 'https://data.atlasfontium.pl/geoserver/wms',
    params: {'LAYERS': 'geonode:akweny', 'TILED': true},
    serverType: 'geoserver',
    transition: 0,
  }),
  visible: false,
  title: 'Jeziora i rzeki główne',
  infoTitle:'Jeziora i rzeki glówne',
  infoContent:'akweny',
  layerName:'akweny',
  permalink:"akweny"
});
export const rzeki = new TileLayer({
  source: new TileWMS({
    url: 'https://data.atlasfontium.pl/geoserver/wms',
    params: {'LAYERS': 'geonode:rzeki', 'TILED': true},
    serverType: 'geoserver',
    transition: 0,
  }),
  visible: false,
  title: 'Rzeki',
  infoTitle:'Rzeki',
  infoContent:'rzeki',
  layerName:'rzeki',
  permalink:"rzeki"
});
export const bagna = new TileLayer({
  source: new TileWMS({
    url: 'https://data.atlasfontium.pl/geoserver/wms',
    params: {'LAYERS': 'geonode:bagna', 'TILED': true},
    serverType: 'geoserver',
    transition: 0,
  }),
  visible: false,
  title: 'Bagna',
  infoTitle:'Bagna',
  infoContent:'bagna',
  layerName:'bagna',
  permalink:"bagna"
});

export const lasy = new TileLayer({
  source: new TileWMS({
    url: 'https://data.atlasfontium.pl/geoserver/wms',
    params: {'LAYERS': 'geonode:lasy', 'TILED': true},
    serverType: 'geoserver',
    transition: 0,
  }),
  visible: false,
  title: 'Lasy',
  infoTitle:'Lasy',
  infoContent:'lasy',
  layerName:'lasy',
  permalink:"lasy"
});


// REJESTRY

function addRegister(lata,powiat,powiat_miasto, title,extent) {
  var layers=[];
  for (const rok of lata) {
    var nazwa = powiat+'_'+rok;
    if(powiat=='kruszwicki'|| powiat=='radziejowski'|| powiat=='brzeski'|| powiat=='kowalski'|| powiat=='przedecki'){
      var content='brzeskie_'+rok
    }else if(powiat=='inowroclawski'|| powiat=='bydgoski'){
      var content = 'inowroclawskie_'+rok;
    }else if(powiat=='dobrzynski'|| powiat=='rypinski'|| powiat=='lipnowski'){
      var content = 'dobrzynskie';
    }else{
      var content = powiat+'_'+rok;
    }
    nazwa = new VectorLayer({
      source: new VectorSource({
        format: new GeoJSON(),
        url: function () {
          return (
            'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
            'version=1.1.0&request=GetFeature&typename=geonode:'+powiat+'&' +
            'outputFormat=application/json&srsname=EPSG:3857&' +
            'cql_filter=rok=' + rok
          )},
      }),
      visible: false,
      title: powiat_miasto+' '+rok,
      infoTitle: title+' '+rok+' r.',
      layerName: nazwa,
      infoContent:content,
      permalink: nazwa,
      extent:extent,
      minZoom:11,
      style: rejestrStyleFunc,
    });
    layers.unshift(nazwa);
  }
  return layers;
}

function addSingleRegister(rok,powiat,powiat_miasto, title,extent) {
  var nazwa = powiat+'_'+rok;
   return nazwa = new VectorLayer({
    source: new VectorSource({
      format: new GeoJSON(),
      url: function () {
        return (
          'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
          'version=1.1.0&request=GetFeature&typename=geonode:'+powiat+'&' +
          'outputFormat=application/json&srsname=EPSG:3857&' +
          'cql_filter=rok=' + rok
        )},
    }),
    visible: false,
    title: powiat_miasto+' '+rok,
    infoTitle: title+' '+rok+' r.',
    layerName: nazwa,
    permalink: nazwa,
    infoContent:nazwa,
    extent:extent,
    minZoom:11,
    style: rejestrStyleFunc,
  });

}

var malborskie=new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: function () {
      return (
        'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
        'version=1.1.0&request=GetFeature&typename=geonode:malborskie&' +
        'outputFormat=application/json&srsname=EPSG:3857&' +
        'cql_filter=rok=1581'
      )},
  }),
  visible: false,
  title: 'Rejestry poborowe woj. malborskiego',
  infoTitle: 'Rejestry poborowe woj. malborskiego 1581 r.',
  infoContent: 'malborskie_1581',
  layerName: 'malborskie_1581',
  permalink: 'malborskie_1581',
  extent: malborskie_extent,
  minZoom:11,
  style: rejestrStyleFunc,
});

var chelminskie=new VectorLayer({
  source: new VectorSource({
    format: new GeoJSON(),
    url: function () {
      return (
        'https://data.atlasfontium.pl/geoserver/wfs?service=WFS&' +
        'version=1.1.0&request=GetFeature&typename=geonode:chelminskie&' +
        'outputFormat=application/json&srsname=EPSG:3857&' +
        'cql_filter=rok=1570'
      )},
  }),
  visible: false,
  title: 'Rejestry poborowe woj. chełmińskiego',
  infoTitle: 'Rejestry poborowe woj. chełmińskiego 1570 r.',
  infoContent:'chelminskie_1570',
  layerName: 'chelminskie_1570',
  permalink: 'chelminskie_1570',
  extent: chelminskie_extent,
  minZoom:11,
  style: rejestrStyleFunc,
});


// REJESTRY WOJ. POZNAŃSKIEGO

const poznanski=['1553','1563','1567','1570','1576','1577','1580','1581','1583']
const koscianski = ['1563', '1565', '1567','1570', '1576','1580','1581','1583'];
const walecki = ['1563', '1577', '1579', '1582'];
const wschowska=['1563','1565','1567','1570','1577','1579','1581','1582','1583']

// REJESTRY WOJ. KALISKIEGO
const gnieznienski=['1564','1565','1576','1577','1579','1580','1581','1582','1583','1588']
const kaliski = ['1552','1563','1564','1565','1576','1579','1580','1581','1591']
const kcynski = ['1564','1565','1576','1577','1578','1579','1581','1582','1583','1591']
const koninski = ['1564','1565','1576','1577','1578','1579','1581','1583']
const nakielski = ['1564','1565','1576','1577','1578','1579','1580','1581','1582','1591']
const pyzdrski = ['1552','1565','1576','1577','1578','1580','1581','1582','1583','1591']

// REJESTRY WOJ. BRZESKIEGO

const kruszwicki=['1553','1557','1567','1570','1577','1579','1580','1581','1582','1583','1589']
const radziejowski=['1553','1557','1567','1570','1577','1579','1580','1581','1582','1583','1589']
const przedecki=['1553','1557','1567','1570','1577','1579','1580','1581','1582','1583','1589']
const brzeski=['1553','1557','1567','1570','1576','1577','1579','1580','1581','1582','1583','1589']
const kowalski=['1553','1557','1567','1570','1577','1579','1580','1581','1582','1583','1589']

const inowroclawskie=['1552','1553','1563','1564','1565','1570','1573','1576','1577','1581','1582','1583','1589']

const dobrzynskie=['1564','1565','1573']
const bielskie=['1577','1578','1579','1580']

// MAPY PODKŁADOWE

const wig = new TileLayer({
  source: new TileWMS({
    url: 'https://pastmaps.cenagis.edu.pl/geoserver/ihpan/wms/',
    params: {'LAYERS': 'topp:wig100k_3857', 'TILED': true},
    serverType: 'geoserver',
    transition: 0,
  }),
  visible: false,
  title: "WIG Mapa taktyczna 1:100 000",
  infoTitle:'WIG Mapa taktyczna 1:100 000', 
  layerName:'wig',
  infoContent:'wig',
});

const ahp = new TileLayer({
  source: new TileWMS({
    url: 'https://pastmaps.cenagis.edu.pl/geoserver/ihpan/wms/',
    params: {'LAYERS': 'topp:ahp_ziemie_polskie_3857', 'TILED': true},
    serverType: 'geoserver',
    transition: 0,
  }),
  visible: false,
  title: "Ziemie polskie Korony w drugiej połowie XVI w.",
  infoTitle:"Ziemie polskie Korony w drugiej połowie XVI w.", 
  layerName:'ahp',
  infoContent:'ahp',
});


// list of layers
export var layers = [
new Group({ 
  title: 'Mapy podkładowe', 
  openInLayerSwitcher: false,
  infoTitle:'Mapy podkładowe', 
  layerName:'mapy_podkladowe',
  infoContent:'mapy_podkladowe',
  layers: [
    osm,
    wig,
    ahp,
]}),

new Group({ 
  title: 'Rejestry poborowe', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe',
  infoContent:'rejestry', 
  layerName:'rejestry',
  permalink:'rejestry', 
  layers: [

    new Group({ 
      title: 'Rejestry poborowe ziemi dobrzyńskiej', 
      openInLayerSwitcher: false, 
      visible:false,
      infoTitle:'Rejestry poborowe ziemi dobrzyńskiej w XVI w.',
      infoContent:'rejestry_ziemi_dobrzynskiej', 
      layerName:'rejestry_ziemi_dobrzynskiej',
      permalink:'rejestry_ziemi_dobrzynskiej', 
      layers: [
        new Group({ 
          title: 'Rejestry poborowe powiatu rypińskiego', 
          infoTitle:'Powiat rypiński w drugiej połowie XVI w.', 
          infoContent:'rejestry_rypinskie',
          layerName:'rejestry_rypinskie',
          permalink:'rejestry_rypinskie', 
          openInLayerSwitcher: false,
          visible:false, 
          layers:addRegister(dobrzynskie,'rypinski','Rejestry rypińskie','Rejestry poborowe powiatu rypińskiego',rypinski_extent)
        }),
        new Group({ 
          title: 'Rejestry poborowe powiatu lipnowskiego', 
          infoTitle:'Powiat lipnowski w drugiej połowie XVI w.', 
          infoContent:'rejestry_lipnowskie',
          layerName:'rejestry_lipnowskie',
          permalink:'rejestry_lipnowskie', 
          openInLayerSwitcher: false,
          visible:false, 
          layers: addRegister(dobrzynskie,'lipnowski','Rejestry lipnowskie','Rejestry poborowe powiatu lipnowskiego',lipnowski_extent),
        }),
        new Group({ 
          title: 'Rejestry poborowe powiatu dobrzyńskiego', 
          infoTitle:'Powiat dobrzyński w drugiej połowie XVI w.', 
          infoContent:'rejestry_dobrzynskie',
          layerName:'rejestry_dobrzynskie',
          permalink:'rejestry_dobrzynskie', 
          openInLayerSwitcher: false,
          visible:false, 
          layers: addRegister(dobrzynskie,'dobrzynski','Rejestry dobrzyńskie','Rejestry poborowe powiatu dobrzyńskiego',dobrzynski_extent),
        }),

        
        
        

    
    ]}),

    new Group({ 
      title: 'Rejestry poborowe woj. pomorskiego', 
      openInLayerSwitcher: false, 
      visible:false,
      infoTitle:'Rejestry poborowe woj. pomorskiego w XVI w.',
      infoContent:'rejestry_woj_pomorskiego', 
      layerName:'rejestry_woj_pomorskiego',
      permalink:'rejestry_woj_pomorskiego', 
      layers: [
        addSingleRegister('1570','pucki','Rejestry puckie','Rejestry poborowe powiatu puckiego',pucki_extent),
        addSingleRegister('1570','mirachowski','Rejestry mirachowskie','Rejestry poborowe powiatu mirachowskiego',mirachowski_extent),
        addSingleRegister('1570','gdanski','Rejestry gdańskie','Rejestry poborowe powiatu gdańskiego',gdanski_extent),
        addSingleRegister('1570','czluchowski','Rejestry człuchowskie','Rejestry poborowe powiatu człuchowskiego',czluchowski_extent),
        addSingleRegister('1570','tucholski','Rejestry tucholskie','Rejestry poborowe powiatu tucholskiego',tucholski_extent),
        addSingleRegister('1570','swiecki','Rejestry świeckie','Rejestry poborowe powiatu świeckiego',swiecki_extent),
        addSingleRegister('1570','tczewski','Rejestry tczewskie','Rejestry poborowe powiatu tczewskiego',tczewski_extent),
        addSingleRegister('1570','nowski','Rejestry nowskie','Rejestry poborowe powiatu nowskiego',nowski_extent),
    
    ]}), 


 malborskie,
chelminskie,

new Group({ 
  title: 'Rejestry poborowe woj. rawskiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. rawskiego w XVI w.',
  infoContent:'rejestry_woj_rawskiego', 
  layerName:'rejestry_woj_rawskiego',
  permalink:'rejestry_woj_rawskiego', 
  layers: [

    addSingleRegister('1581','sochaczewska','Rejestry sochaczewskie','Rejestry poborowe ziemi sochaczewskiej (powiaty sochaczewski i mszczonowski)',sochaczewska_extent),
    addSingleRegister('1581','rawska','Rejestry rawskie','Rejestry poborowe ziemi rawskiej (powiaty rawski i bielski)',rawska_extent),
    addSingleRegister('1581','gostyninska','Rejestry gostynińskie','Rejestry poborowe ziemi gostynińskiej (powiat gostyniński i gąbiński)',gostyninska_extent),

]}), 
new Group({ 
  title: 'Rejestry poborowe woj. mazowieckiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. mazowieckiego w XVI w.', 
  infoContent:'rejestry_woj_mazowieckiego',
  layerName:'rejestry_woj_mazowieckiego',
  permalink:'rejestry_woj_mazowieckiego', 
  layers: [


    addSingleRegister('1569','zakroczymska','Ziemia zakroczymska','Rejestry poborowe ziemi zakroczymskiej',zakroczymska_extent),
    addSingleRegister('1569','wyszogrodzka','Ziemia wyszogrodzka','Rejestry poborowe ziemi wyszogrodzkiej',wyszogrodzka_extent),
    addSingleRegister('1581','wiska','Ziemia wiska','Rejestry poborowe ziemi wiskiej',wiska_extent),
    addSingleRegister('1578','warszawska','Ziemia warszawska','Rejestry poborowe ziemi warszawskiej',warszawska_extent),
    addSingleRegister('1582','rozanska','Ziemia różańska','Rejestry poborowe ziemi różańskiej',rozanska_extent),
    addSingleRegister('1578','nurska','Ziemia nurska','Rejestry poborowe ziemi nurskiej',nurska_extent),
    addSingleRegister('1577','lomzynska','Ziemia łomżyńska','Rejestry poborowe ziemi łomżyńskiej',lomzynska_extent),
    addSingleRegister('1578','liwska','Ziemia liwska','Rejestry poborowe ziemi liwskiej',liwska_extent),
    addSingleRegister('1569','czerska','Ziemia czerska','Rejestry poborowe ziemi czerskiej',czerska_extent),
    addSingleRegister('1580','ciechanowska','Ziemia ciechanowska','Rejestry poborowe ziemi ciechanowskiej',ciechanowska_extent),

]}),

new Group({ 
  title: 'Rejestry poborowe woj. płockiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. płockiego w XVI w.', 
  infoContent:'rejestry_woj_plockiego',
  layerName:'rejestry_woj_plockiego',
  permalink:'rejestry_woj_plockiego', 
  layers: [

    addSingleRegister('1578','niedzborski','Powiat niedzborski','Rejestry poborowe powiatu niedzborskiego',niedzborski_extent),
    addSingleRegister('1578','mlawski','Powiat mławski','Rejestry poborowe powiatu mławskiego',mlawski_extent),
    addSingleRegister('1578','szrenski','Powiat szreński','Rejestry poborowe powiatu szreńskiego',szrenski_extent),
    addSingleRegister('1578','plonski','Powiat płoński','Rejestry poborowe powiatu płońskiego',plonski_extent),
    addSingleRegister('1578','raciaski','Powiat raciąski','Rejestry poborowe powiatu raciąskiego',raciaski_extent),
    addSingleRegister('1578','sierpecki','Powiat sierpecki','Rejestry poborowe powiatu sierpeckiego',sierpecki_extent),
    addSingleRegister('1578','bielski','Powiat bielski','Rejestry poborowe powiatu bielskiego',bielski_extent),
    addSingleRegister('1578','plocki','Powiat płocki','Rejestry poborowe powiatu płockiego',plocki_extent),
  
    
]}),

new Group({ 
  title: 'Rejestry poborowe woj. inowrocławskiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. inowrocławskiego w XVI w.', 
  infoContent:'rejestry_woj_inowroclawskiego',
  layerName:'rejestry_woj_inowroclawskiego',
  permalink:'rejestry_woj_inowroclawskiego', 
  layers: [



    new Group({ 
      title: 'Rejestry poborowe powiatu inowrocławskiego', 
      infoTitle:'Powiat inowrocławski w drugiej połowie XVI w.', 
      infoContent:'rejestry_inowroclawskie',
      layerName:'rejestry_inowroclawskie',
      permalink:'rejestry_inowroclawskie', 
      openInLayerSwitcher: false,
      visible:false, 
      layers: addRegister(inowroclawskie,'inowroclawski','Rejestry inowrocławskie','Rejestry poborowe powiatu inowrocławskiego',inowroclawski_extent)
    }),

    new Group({ 
      title: 'Rejestry poborowe powiatu bydgoskiego', 
      infoTitle:'Powiat bydgoski w drugiej połowie XVI w.', 
      infoContent:'rejestry_bydgoskie',
      layerName:'rejestry_bydgoskie',
      permalink:'rejestry_bydgoskie', 
      openInLayerSwitcher: false,
      visible:false, 
      layers: addRegister(inowroclawskie,'bydgoski','Rejestry bydgoskie','Rejestry poborowe powiatu bydgoskiego',bydgoski_extent)
    }),
    
]}), 

new Group({ 
  title: 'Rejestry poborowe woj. brzeskiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. brzeskiego w XVI w.', 
  infoContent:'rejestry_woj_brzeskiego',
  layerName:'rejestry_woj_brzeskiego',
  permalink:'rejestry_woj_brzeskiego', 
  layers: [



    new Group({ 
      title: 'Rejestry poborowe powiatu radziejowskiego', 
      infoTitle:'Powiat radziejowski w drugiej połowie XVI w.', 
      infoContent:'rejestry_radziejowskie',
      layerName:'rejestry_radziejowskie',
      permalink:'rejestry_radziejowskie', 
      openInLayerSwitcher: false,
      visible:false, 
      layers: addRegister(radziejowski,'radziejowski','Rejestry radziejowskie','Rejestry poborowe powiatu radziejowskiego',radziejowski_extent)
    }),

    new Group({ 
      title: 'Rejestry poborowe powiatu przedeckiego', 
      infoTitle:'Powiat radziejowski w drugiej połowie XVI w.', 
      infoContent:'rejestry_przedeckie',
      layerName:'rejestry_przedeckie',
      permalink:'rejestry_przedeckie', 
      openInLayerSwitcher: false,
      visible:false, 
      layers: addRegister(przedecki,'przedecki','Rejestry przedeckie','Rejestry poborowe powiatu przedeckiego',przedecki_extent)
    }),

    new Group({ 
      title: 'Rejestry poborowe powiatu kruszwickiego', 
      infoTitle:'Powiat kruszwicki w drugiej połowie XVI w.', 
      infoContent:'rejestry_kruszwickie',
      layerName:'rejestry_kruszwickie',
      permalink:'rejestry_kruszwickie', 
      openInLayerSwitcher: false,
      visible:false, 
      layers: addRegister(kruszwicki,'kruszwicki','Rejestry kruszwickie','Rejestry poborowe powiatu kruszwickiego',kruszwicki_extent)
    }),

    new Group({ 
      title: 'Rejestry poborowe powiatu kowalskiego', 
      infoTitle:'Powiat kowalski w drugiej połowie XVI w.', 
      infoContent:'rejestry_kowalskie',
      layerName:'rejestry_kowalskie',
      permalink:'rejestry_kowalskie', 
      openInLayerSwitcher: false,
      visible:false, 
      layers: addRegister(kowalski,'kowalski','Rejestry kowalskie','Rejestry poborowe powiatu kowalskiego',kowalski_extent)
    }),

    new Group({ 
      title: 'Rejestry poborowe powiatu brzeskiego', 
      infoTitle:'Powiat brzeski w drugiej połowie XVI w.', 
      infoContent:'rejestry_brzeskie',
      layerName:'rejestry_brzeskie',
      permalink:'rejestry_brzeskie', 
      openInLayerSwitcher: false,
      visible:false, 
      layers: addRegister(brzeski,'brzeski','Rejestry brzeskie','Rejestry poborowe powiatu brzeskiego',brzeski_extent)
    }),
    
]}), 

new Group({ 
  title: 'Rejestry poborowe woj. łęczyckiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. łęczyckiego w XVI w.', 
  infoContent:'rejestry_woj_leczyckiego',
  layerName:'rejestry_woj_leczyckiego',
  permalink:'rejestry_woj_leczyckiego', 
  layers: [

    addSingleRegister('1580','orlowski','Powiat orłowski','Rejestry poborowe powiatu orłowskiego',orlowski_extent),
    addSingleRegister('1580','brzezinski','Powiat brzeziński','Rejestry poborowe powiatu brzezińskiego',brzezinski_extent),
    addSingleRegister('1580','leczycki','Powiat łęczycki','Rejestry poborowe powiatu łęczyckiego',leczycki_extent),
  
    
]}), 

new Group({ 
  title: 'Rejestry poborowe woj. sieradzkiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. sieradzkiego w XVI w.', 
  infoContent:'rejestry_woj_sieradzkiego',
  layerName:'rejestry_woj_sieradzkiego',
  permalink:'rejestry_woj_sieradzkiego', 
  layers: [

    addSingleRegister('1564','wielunski','rejestry wieluńskie','Rejestry poborowe powiatu wielunskiego',wielunski_extent),
    addSingleRegister('1564','szadkowski','Rejestry szadkowskie','Rejestry poborowe powiatu szadkowskiego',szadkowski_extent),
    addSingleRegister('1564','sieradzki','Rejestry sieradzkie','Rejestry poborowe powiatu sieradzkiego',sieradzki_extent),
    addSingleRegister('1564','radomszczanski','Rejestry radomszczańskie','Rejestry poborowe powiatu radomszczańskiego',radomszczanski_extent),
    addSingleRegister('1564','piotrkowski','Rejestry piotrkowskie','Rejestry poborowe powiatu piotrkowskiego',piotrkowski_extent),
    addSingleRegister('1564','ostrzeszowski','Rejestry ostrzeszowskie','Rejestry poborowe powiatu ostrzeszowskiego',ostrzeszowski_extent),
  
    
]}), 
new Group({ 
  title: 'Rejestry poborowe woj. kaliskiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. kaliskiego w XVI w.', 
  infoContent:'rejestry_woj_kaliskiego',
  layerName:'rejestry_woj_kaliskiego',
  permalink:'rejestry_woj_kaliskiego', 
  layers: [
  
  new Group({ 
    title: 'Rejestry pyzdrskie', 
    infoTitle:'Powiat pyzdrski w drugiej połowie XVI w.', 
    infoContent:'rejestry_pyzdrskie',
    layerName:'rejestry_pyzdrskie',
    permalink:'rejestry_pyzdrskie', 
    openInLayerSwitcher: false,
    visible:false, 
    layers: addRegister(pyzdrski,'pyzdrski','Rejestry pyzdrskie','Rejestry poborowe powiatu pyzdrskiego',pyzdrskie_extent)
  }),
  
  new Group({ 
    title: 'Rejestry nakielskie', 
    infoTitle:'Powiat nakielski w drugiej połowie XVI w.', 
    infoContent:'rejestry_nakielskie',
    layerName:'rejestry_nakielskie',
    permalink:'rejestry_nakielskie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(nakielski,'nakielski','Rejestry nakielskie','Rejestry poborowe powiatu nakielskiego',nakielskie_extent)
  }),
    
  new Group({ 
    title: 'Rejestry konińskie', 
    infoTitle:'Powiat koniński w drugiej połowie XVI w.', 
    infoContent:'rejestry_koninskie',
    layerName:'rejestry_koninskie',
    permalink:'rejestry_koninskie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(koninski,'koninski','Rejestry konińskie','Rejestry poborowe powiatu koninskiego',koninskie_extent)
  }),
  new Group({ 
    title: 'Rejestry kcyńskie', 
    infoTitle:'Powiat kcyński w drugiej połowie XVI w.', 
    infoContent:'rejestry_kcynskie',
    layerName:'rejestry_kcynskie',
    permalink:'rejestry_kcynskie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(kcynski,'kcynski','Rejestry kcyńskie','Rejestry poborowe powiatu kcyńskiego',kcynskie_extent)
  }),
    
  new Group({ 
    title: 'Rejestry kaliskie', 
    infoTitle:'Powiat kaliski w drugiej połowie XVI w.', 
    infoContent:'rejestry_kaliskie',
    layerName:'rejestry_kaliskie',
    permalink:'rejestry_kaliskie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(kaliski,'kaliski','Rejestry kaliskie','Rejestry poborowe powiatu kaliskiego',kaliskie_extent)
  }),
  new Group({ 
    title: 'Rejestry gnieźnieńskie', 
    infoTitle:'Powiat gnieźnieński w drugiej połowie XVI w.', 
    infoContent:'rejestry_gnieznienskie',
    layerName:'rejestry_gnieznienskie',
    permalink:'rejestry_gnieznienskie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(gnieznienski,'gnieznienski','Rejestry gnieźnieńskie','Rejestry poborowe powiatu gnieźnieńskiego',gnieznienskie_extent)
  }),

]}), 
new Group({ 
  title: 'Rejestry poborowe woj. poznańskiego', 
  openInLayerSwitcher: false,
  infoTitle:'Rejestry poborowe woj. poznańskiego w XVI w.', 
  infoContent:'rejestry_woj_poznanskiego',
  layerName:'rejestry_woj_poznanskiego',
  permalink:'rejestry_woj_poznanskiego',
  visible:false,  
  layers: [
  new Group({ 
    title: 'Rejestry wałeckie', 
    infoTitle:'Powiat wałecki w drugiej połowie XVI w.', 
    infoContent:'rejestry_waleckie',
    layerName:'rejestry_waleckie',
    permalink:'rejestry_waleckie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(walecki,'walecki','Rejestry wałeckie','Rejestry poborowe powiatu wałeckiego',waleckie_extent)
  }),
  new Group({ 
    title: 'Rejestry ziemi wschowskiej', 
    infoTitle:'Ziemia wschowska w drugiej połowie XVI w.', 
    infoContent:'rejestry_wschowskie',
    layerName:'rejestry_wschowskie',
    permalink:'rejestry_wschowskie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(wschowska,'wschowska','Rejestry wschowskie','Rejestry poborowe ziemi wschowskiej',wschowska_extent)
  }),
  new Group({ 
    title: 'Rejestry poznańskie', 
    infoTitle:'Powiat poznański w drugiej połowie XVI w.', 
    infoContent:'rejestry_poznanskie',
    layerName:'rejestry_poznanskie',
    permalink:'rejestry_poznanskie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(poznanski,'poznanski','Rejestry poznańskie','Rejestry poborowe powiatu poznańskiego',poznanskie_extent)
  }),
  new Group({ 
    title: 'Rejestry kościańskie', 
    infoTitle:'Powiat kościański w drugiej połowie XVI w.', 
    infoContent:'rejestry_koscianskie',
    layerName:'rejestry_koscianskie',
    permalink:'rejestry_koscianskie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(koscianski,'koscianski','Rejestry kościańskie','Rejestry poborowe powiatu kościańskiego',koscianskie_extent)
  }),
  
]}),
new Group({ 
  title: 'Rejestry poborowe woj. podlaskiego', 
  openInLayerSwitcher: false,
  infoTitle:'Rejestry poborowe woj. podlaskiego w XVI w.', 
  infoContent:'rejestry_woj_podlaskiego',
  layerName:'rejestry_woj_podlaskiego',
  permalink:'rejestry_woj_podlaskiego',
  visible:false,  
  layers: [
  new Group({ 
    title: 'Rejestry bielskie', 
    infoTitle:'Powiat bielski w drugiej połowie XVI w.', 
    infoContent:'rejestry_bielskie',
    layerName:'rejestry_bielskie',
    permalink:'rejestry_bielskie', 
    openInLayerSwitcher: false,
    visible:false,  
    layers: addRegister(bielskie,'bielski_pdl','Rejestry bielskie','Rejestry poborowe powiatu bielskiego',bielski_pdl_extent)
  }),
  
]}),
new Group({ 
  title: 'Rejestry poborowe woj. lubelskiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. lubelskiego w XVI w.', 
  infoContent:'rejestry_woj_lubelskiego',
  layerName:'rejestry_woj_lubelskiego',
  permalink:'rejestry_woj_lubelskiego', 
  layers: [


    addSingleRegister('1563','urzedowski','Powiat urzędowski','Rejestry poborowe powiatu urzędowskiego',urzedowski_extent),
    addSingleRegister('1580','lukowski','Powiat łukowski','Rejestry poborowe powiatu łukowskiego',lukowski_extent),
    addSingleRegister('1563','lubelski','Powiat lubelski','Rejestry poborowe powiatu lubelskiego',lubelski_extent),


]}), 

new Group({ 
  title: 'Rejestry poborowe woj. sandomierskiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. sandomierskiego w XVI w.', 
  infoContent:'rejestry_woj_sandomierskiego',
  layerName:'rejestry_woj_sandomierskiego',
  permalink:'rejestry_woj_sandomierskiego', 
  layers: [

    addSingleRegister('1577','wislicki','Powiat wiślicki','Rejestry poborowe powiatu wiślickiego',wislicki_extent),
    addSingleRegister('1576','stezycki','Powiat stężycki','Rejestry poborowe powiatu stężyckiego',stezycki_extent),
    addSingleRegister('1577','sandomierski','Powiat sandomierski','Rejestry poborowe powiatu sandomierskiego',sandomierski_extent),
    addSingleRegister('1577','radomski','Powiat radomski','Rejestry poborowe powiatu radomskiego',radomski_extent),
    addSingleRegister('1577','pilznenski','Powiat pilzneński','Rejestry poborowe powiatu pilzneńskiego',pilznenski_extent),
    addSingleRegister('1577','opoczynski','Powiat opoczyński','Rejestry poborowe powiatu opoczyńskiego',opoczynski_extent),
    addSingleRegister('1577','checinski','Powiat chęciński','Rejestry poborowe powiatu chęcińskiego',checinski_extent)
  
    
]}), 

new Group({ 
  title: 'Rejestry poborowe woj. krakowskiego', 
  openInLayerSwitcher: false, 
  visible:false,
  infoTitle:'Rejestry poborowe woj. krakowskiego w XVI w.', 
  infoContent:'rejestry_woj_krakowskiego',
  layerName:'rejestry_woj_krakowskiego',
  permalink:'rejestry_woj_krakowskiego', 
  layers: [

    addSingleRegister('1581','sadecki','Powiat sądecki','Rejestry poborowe powiatu sądeckiego',sadecki_extent),
    addSingleRegister('1581','biecki','Powiat biecki','Rejestry poborowe powiatu bieckiego',biecki_extent),
    addSingleRegister('1581','slaski','Powiat śląski','Rejestry poborowe powiatu śląskiego',slaski_extent),
    addSingleRegister('1581','ksieski','Powiat księski','Rejestry poborowe powiatu księskiego',ksieski_extent),
    addSingleRegister('1581','lelowski','Powiat lelowski','Rejestry poborowe powiatu lelowskiego',lelowski_extent),
    addSingleRegister('1581','szczyrzycki','Powiat szczyrzycki','Rejestry poborowe powiatu szczyrzyckiego',szczyrzycki_extent),
    addSingleRegister('1581','proszowski','Powiat proszowski','Rejestry poborowe powiatu proszowskiego',proszowski_extent)
  
    
]}), 
]}), 

//]}),

  new Group({ 
    title: 'Pokrycie terenu', 
    openInLayerSwitcher: false, 
    infoTitle:'Pokrycie terenu', 
    infoContent:'pokrycie_terenu',
    layerName:'pokrycie_terenu',
    permalink:'pokrycie_terenu',
    visible:false,
    layers: [
    lasy,
    bagna,
    rzeki,
    akweny,
    drogi,
  ]}),
  new Group({ 
    title: 'Państwowe granice administracyjne', 
    openInLayerSwitcher: false,
    infoTitle:'Państwowe granice administracyjne', 
    infoContent:'panstwowe_granice_administracyjne',
    layerName:'panstwowe_granice_administracyjne',
    permalink:'panstwowe_granice_administracyjne', 
    visible:false,
    layers: [
    powiaty,
    ziemie,
    wojewodztwa,
  ]}),
  new Group({ 
    title: 'Kościelne granice administracyjne', 
    openInLayerSwitcher: false,
    infoTitle:'Kościelne granice administracyjne', 
    infoContent:'koscielne_granice_administracyjne',
    layerName:'koscielne_granice_administracyjne',
    permalink:'koscielne_granice_administracyjne',
    visible:false,  
    layers: [
    parafie,
    dekanaty,
    archidiakonaty,
    diecezje,
  ]}),
  
  miejscowosci,
  capital,
  vector,

];